import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import media from '../../styles/config/mediaQueries';
import { StyledWrapper } from '../common/Wrapper/Wrapper.styles';

export const StyledContainer = styled.section`
  ${media.mobile`
    padding: 25px 0 22px;
    background-color: ${props => (props.bgcolor ? rgba(theme.color.red, 0.7) : theme.color.black)};
    border-bottom: 1px solid ${rgba(theme.color.white, 0.1)};
    ${props =>
      props.mobileVertical &&
      `
        background: none;
        ${StyledWrapper}{
          padding: 0;
        }
    `};
  `}
  ${media.desktop`
    margin-bottom: 26px;
    padding-bottom: ${props => (props.type === 'sidebar' ? '0' : '26px')};
    padding-left: ${props => (props.type === 'sidebar' ? '7px' : '0')};
    border-bottom:
    ${props => (props.type === 'sidebar' || !props.border ? '0' : '1px')} solid ${rgba(
    theme.color.white,
    0.1
  )};
  `}
`;
